/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Date_In_FutureInputs */

const vi_einvoice_err_date_in_future = /** @type {(inputs: Einvoice_Err_Date_In_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hóa đơn không được ở tương lai`)
};

/**

* @param {Einvoice_Err_Date_In_FutureInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_date_in_future = /** @type {((inputs?: Einvoice_Err_Date_In_FutureInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Date_In_FutureInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_date_in_future(inputs)
});